import { render, staticRenderFns } from "./ShowAssignationsButton.vue?vue&type=template&id=1f61edf8&"
import script from "./ShowAssignationsButton.vue?vue&type=script&lang=js&"
export * from "./ShowAssignationsButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports